<template>
    <div class="Orientacao">
        <HeaderLogado></HeaderLogado>
        <Pesquisa></Pesquisa>

        <div class="container" v-if="pergunta != null">
            <div class="row">
                <div class="col-12 my-4">
                    <span class="txt-p txt-roxo-1 txt-w-bold txt-size-16 c-pointer" @click="voltar"><i class="fas fa-arrow-left"></i> Voltar </span>
                </div>
                <div class="col-12">
                    <span class="txt-p txt-cores-6 txt-w-5 txt-size-16">Pergunta nº {{id}}</span>
                </div>

            </div>
            <div class="row">
                <div class="col-12 col-md-9 d-flex justify-content-between align-items-center">
                    <div class="me-2">
                        <span class="txt-p txt-cores-6 txt-w-bold txt-size-20">{{pergunta.dsAssunto}}</span>
                    </div>
                    <div>
                        <span class="txt-p txt-cores-6 txt-w-5 txt-size-16">Modalidade</span>
                        <p class="txt-p txt-cores-1 txt-w-5 txt-size-16"> <i :class="pergunta.tipoPergunta.icone"></i> {{pergunta.tipoPergunta.nmTipoPergunta}}</p>
                    </div>
                </div>
                <div class="col-12 col-md-3">

                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-9">
                    <div class="box-borda-cinza h-100">
                        <div class="row h-100 align-items-center">
                            <div class="col-12 col-md-3 d-flex align-items-center">
                                <span class="txt-p txt-cores-6 txt-w-bold txt-size-16">
                                    Informações e andamento
                                </span>
                            </div>
                            <div class="col-12 col-md-7 d-flex justify-content-between ">
                                <div class="d-flex">
                                    <div>
                                        <i class="fas fa-calendar-alt txt-roxo-1 txt-size-16"></i>
                                    </div>
                                    <div class="px-3">
                                        <span class="txt-p txt-size-14 txt-w-5 txt-cores-1">
                                            Solicitado
                                        </span>
                                        <p class="txt-p txt-size-14 txt-cores-1 txt-w-bold mb-0">{{pergunta.dtPerguntaFormat}}</p>
                                    </div>
                                </div>
                                <div class="d-flex" v-if="pergunta.perguntaEtapa != null">
                                    <div>
                                        <i class="fas fa-hourglass txt-roxo-1 txt-size-16"></i>
                                    </div>
                                    <div class="px-3">
                                        <template v-if="pergunta.perguntaEtapa.nmEtapa == 'Complemento'">
                                            <span class="txt-p txt-size-14 txt-w-5 txt-cores-1">
                                                Aguardando complemento
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span class="txt-p txt-size-14  txt-w-5 txt-cores-1">
                                                Previsto
                                            </span>
                                            <p class="txt-p txt-size-14 txt-cores-1 txt-w-bold mb-0">{{pergunta.dtPrazoFormat}}</p>
                                        </template>
                                    </div>
                                </div>
                                <div class="d-flex" v-if="pergunta.perguntaEtapa != null">
                                    <div>
                                        <i class="fas fa-calendar txt-roxo-1 txt-size-16" v-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada' || pergunta.perguntaEtapa.nmEtapa == 'Cancelada'"></i>
                                        <i class="fas fa-calendar-check txt-roxo-1 txt-size-16" v-else></i>
                                    </div>
                                    <div class="px-3">
                                        <template v-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada' || pergunta.perguntaEtapa.nmEtapa == 'Cancelada'">
                                            <span class="txt-p txt-size-14  txt-w-5 txt-cores-1">
                                                Finalizado
                                            </span>
                                            <p class="txt-p txt-size-14 txt-cores-1 txt-w-bold mb-0">{{pergunta.dtMovimento}}</p>
                                        </template>
                                        <template v-else>
                                            <span class="txt-p txt-size-14  txt-w-5 txt-cores-1">
                                                Última interação
                                            </span>
                                            <p class="txt-p txt-size-14 txt-cores-1 txt-w-bold mb-0">{{pergunta.dtMovimento}}</p>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 d-none d-md-flex justify-content-end align-items-center px-4">
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 mt-2 mt-md-0">
                    <div class="box-borda-roxo d-flex flex-column justify-content-center h-100" v-if="pergunta.perguntaEtapa != null">
                        <span class="txt-p txt-cores-6 txt-w-5 txt-size-16">Status</span>

                        <p class="txt-p txt-size-20 txt-w-5 mb-0 txt-info" v-if="pergunta.perguntaEtapa.nmEtapa == 'Abertura' || pergunta.perguntaEtapa.nmEtapa == 'Andamento' || pergunta.perguntaEtapa.nmEtapa == 'Encaminhada'">
                            <i class="fas fa-hourglass"></i> Aguardando atendimento
                        </p>
                        <p class="txt-p txt-size-20 txt-w-5 mb-0 txt-info" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Iniciada'">
                            <i class="fas fa-hourglass"></i> Aguardando resposta
                        </p>
                        <p class="txt-p txt-size-20 txt-w-5 mb-0 txt-info" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Complemento'">
                            <i class="fa fa-reply ico-retorno"></i> Aguardando Retorno
                        </p>

                        <p class="txt-p txt-size-20 txt-w-5 mb-0 txt-sucess" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada'">
                            <i class="fas fa-envelope"></i> Respondido
                        </p>

                        <p class="txt-p txt-size-20 txt-w-5 mb-0 txt-erro" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Cancelada'">
                            <i class="fas fa-times"></i> Cancelado
                        </p>

                        <p class="txt-p txt-size-20 txt-w-5 mb-0 txt-cores-6" v-else>
                            <i class="fas fa-sync-alt"></i> Sem dados
                        </p>

                    </div>
                </div>
            </div>

            <div class="row my-4">
                <div class="col-12 col-md-9">
                    <!-- AUDIOS -->
                    <div class="box-borda-cinza mb-3" v-if="pergunta.lstPerguntaAudio.length > 0">
                        <div class="row">
                            <div class="col-12">
                                <span class="txt-p txt-cores-1 txt-w-500 txt-size-16">
                                    <i class="far fa-file-audio"></i> Áudios
                                </span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-4" v-for="(item,index) in pergunta.lstPerguntaAudio" :key="index">
                                <div class="item-arquivo-audio">
                                    <span class="txt-p txt-cores-1 txt-w-bold txt-size-16">{{item.nmArquivo}}</span>
                                    <a :href="item.urlArquivo" download class="btn btn-roxo btn-sm">
                                        Download
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Dilatacao prazo -->
                    <div class="" v-if="pergunta.perguntaDilatacaoPrazo">
                        <template v-if="pergunta.perguntaDilatacaoPrazo.flAceite == 'Não' && pergunta.perguntaDilatacaoPrazo.dtAceite == null && (pergunta.perguntaEtapa.nmEtapa != 'Finalizada' && pergunta.perguntaEtapa.nmEtapa == 'Cancelada')">
                            <div class="box-borda-cinza mb-3">
                                <div class="row">
                                    <div class="col-12">
                                        <span class="txt-p txt-cores-1 txt-w-500 txt-size-16">
                                            Dilatação de Prazo
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <p class="bold"><span class="txtApp"><i class="fa fa-calendar txtApp"></i> {{pergunta.perguntaDilatacaoPrazo.dtInclusao}} •</span> Prezado Cliente, foi solicitada uma Dilatação no prazo pelo consultor(a) {{pergunta.atendente.nmUsuario}}</p>
                                        <hr />
                                        <p class="bold"><span class="txtApp">Novo Prazo:</span> {{pergunta.perguntaDilatacaoPrazo.dtPrazo}}</p>

                                        <p class="bold"><span class="txtApp">Motivo:</span> <span v-html="pergunta.perguntaDilatacaoPrazo.dsMotivo"></span></p>
                                    </div>
                                    <div class="col-12">
                                        <button type="button" class="btn btn-success bold" @click="mudarPrazo(pergunta.perguntaDilatacaoPrazo.idPerguntaDilatacaoPrazo, 'Sim')"><i class="fa fa-check"></i> Aceitar</button>
                                        <button type="button" class="btn btn-vermelho bold" @click="mudarPrazo(pergunta.perguntaDilatacaoPrazo.idPerguntaDilatacaoPrazo, 'Não')"><i class="fa fa-times"></i> Recusar</button>
                                    </div>
                                </div>
                            </div>

                        </template>
                        <template v-if="pergunta.perguntaDilatacaoPrazo.dtAceite != null">
                            <div class="box-borda-cinza mb-3">
                                <div class="pergunta">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-cores-1">
                                        <i class="far fa-calendar me-2"></i>
                                        {{pergunta.perguntaDilatacaoPrazo.dtInclusao}}
                                        <template v-if="pergunta.perguntaDilatacaoPrazo.flAceite == 'Sim'">
                                            Aceita a Dilatação no prazo em {{pergunta.perguntaDilatacaoPrazo.dtAceite}}
                                        </template>
                                        <template v-else>
                                            Recusada a Dilatação no prazo em {{pergunta.perguntaDilatacaoPrazo.dtAceite}}
                                        </template>
                                    </span>
                                    <p class="px-4 mt-2 txt-p txt-cores-1">
                                        Novo Prazo: {{pergunta.perguntaDilatacaoPrazo.dtPrazo}}
                                    </p>
                                    <p class="px-4 mt-2 txt-p txt-cores-1">
                                        Motivo: {{pergunta.perguntaDilatacaoPrazo.dsMotivo}}
                                    </p>
                                </div>
                            </div>

                        </template>
                    </div>

                    <div class="box-borda-cinza">
                        <div class="pergunta">
                            <span class="txt-p txt-size-16 txt-w-5 txt-cores-1" v-if="pergunta.solicitante != null"><i class="far fa-comment-alt me-2"></i> {{pergunta.solicitante.nmUsuario}}</span>
                            <p class="px-4 mt-2 txt-p txt-cores-1" v-html="pergunta.dsPergunta">
                            </p>
                        </div>

                        <div class="pt-3" v-for="(item,index) in pergunta.lstPerguntaMovimento" :key="index" v-if="pergunta.atendente != null">
                            <template v-if="item.idEtapa == 6">
                                <!--etapa 6-->
                                <!-- FINALIZADA -->
                                <div class="resposta resposta-rigth">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> Prezado Cliente, sua solicitação foi finalizada pelo consultor(a) {{pergunta.atendente.nmUsuario}}</span>
                                    <!-- lstResultadoArquivo -->

                                    <template v-if="item.dsMovimento.indexOf('com a seguinte observação') != -1">
                                        <hr />
                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                    </template>

                                </div>
                                <div class="resposta resposta-rigth" v-if="pergunta.lstPerguntaMovimentoArquivo.length > 0">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-file me-2"></i> Arquivos</span>

                                    <div class="mt-2" v-for="(arquivo, index) in pergunta.lstPerguntaMovimentoArquivo" :key="index">
                                        <a :href="arquivo.urlArquivo" download class="btn btn-roxo btn-sm">
                                            <i class="fas fa-file-download mr-1"></i> Download
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="item.idEtapa == 5">
                                <!--etapa 5-->
                                <!-- COMPLEMENTO -->
                                <template v-if="index == 0">

                                    <div class="pergunta mb-3">
                                        <span class="txt-p txt-size-16 txt-w-5 txt-cores-1"><i class="far fa-comment-alt me-2"></i> Prezado Cliente, favor encaminhar as informações solicitadas pelo consultor(a) {{pergunta.atendente.nmUsuario}} <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                        <p class="px-4 mt-2 txt-p txt-cores-1" v-html="item.dsPergunta"></p>
                                        <form id="formComplemento" v-if="showComplemento">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <textarea class="form-control" rows="5" id="txt_dsMovimento" placeholder="Insira aqui as informações complementares" v-model="complemento" required></textarea>
                                                </div>
                                            </div>
                                            <div class="d-flex w-100 justify-content-end mt-2">
                                                <button class="btn btn-roxo" @click="complementaInformacao(item.idMovimento)" type="button"><i class="fas fa-paper-plane txt-white"></i> Enviar</button>
                                            </div>
                                        </form>
                                        <div v-else>
                                            <button class="btn btn-roxo" type="button" @click="showComplemento = true"><i class="fas fa-comment-alt"></i> Complementar informação</button>
                                        </div>
                                    </div>
                                    <div class="resposta resposta-rigth">
                                        <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-circle me-2"></i> Solicitação de complemento <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="resposta resposta-rigth">
                                        <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-circle me-2"></i> Solicitação de complemento <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span></span>
                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="item.idEtapa == 7">
                                <!--etapa 7-->
                                <!-- CANCELADA -->
                                <div class="resposta">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> Prezado Cliente, a sua solicitação foi cancelada pelo consultor(a) {{pergunta.atendente.nmUsuario}} <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span></span>
                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                </div>
                            </template>
                            <template v-else-if="item.idEtapa == 2">
                                <!--etapa 2-->
                                <!-- RETORNO -->
                                <div class="resposta">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-circle me-2"></i> Encaminhamento de complemento <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                </div>
                            </template>
                            <template v-else-if="item.idEtapa == 4">
                                <!--etapa 4-->
                                <div class="resposta resposta-rigth">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> SISTEMA <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                </div>
                            </template>
                            <template v-else-if="item.idEtapa == 3">
                                <!--etapa 3-->
                                <div class="resposta resposta-rigth">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> SISTEMA <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                </div>
                            </template>
                            <template v-else>
                                <!--etapa 1-->
                                <div class="resposta">
                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> {{pergunta.solicitante.nmUsuario}} <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="item.dsMovimento"></p>
                                </div>
                            </template>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-md-3 mt-2 mt-md-0" v-if="pergunta.solicitante != null">
                    <div class="d-flex">
                        <div class="txt-p txt-w-5 txt-roxo-1 txt-size-16">
                            <i class="fas fa-user"></i>
                        </div>
                        <div class="txt-p txt-w-5 txt-size-16 ms-2">
                            <span class=" txt-roxo-1 ">
                                Usuário
                            </span>
                            <p class="txt-cores-1">
                                {{pergunta.solicitante.nmUsuario}}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="txt-p txt-w-5 txt-roxo-1 txt-size-16">
                            <i class="fas fa-phone-alt"></i>
                        </div>
                        <div class="txt-p txt-w-5 txt-size-16 ms-2">
                            <span class=" txt-roxo-1 ">
                                Telefone
                            </span>
                            <p class="txt-cores-1">
                                {{pergunta.nrTelefoneContato}}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="txt-p txt-w-5 txt-roxo-1 txt-size-16">
                            <i class="fas fa-envelope"></i>
                        </div>
                        <div class="txt-p txt-w-5 txt-size-16 ms-2">
                            <span class=" txt-roxo-1 ">
                                E-mail
                            </span>
                            <p class="txt-cores-1">
                                {{pergunta.solicitante.dsEmail}}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div v-else>
            <div class="container" v-if="concluido">
                <div class="row justify-content-center">
                    <div class="col-6 text-center py-5 my-5">
                        <p class="txt-h-1 txt-roxo-1">
                            Pergunta não encontrada
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import { urlApi, avisoErro, getIconeTipoPergunta } from '@/config/global'

    import HeaderLogado from '@/components/HeaderLogado'
    import Footer from '@/components/Footer'
    import Pesquisa from '@/components/Pesquisa'

    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'Orientacao',
        components: { HeaderLogado, Footer, Pesquisa },
        props: ['id'],
        data: function () {
            return {
                pergunta: null,
                concluido: false,

                showComplemento: false,

                complemento: "",
            }
        },
        methods: {

            voltar() {
                this.$router.go(-1)
            },

            load() {
                let $this = this;
                $this.concluido = false;
                axios.get(`${urlApi}/Pergunta/GetPerguntaCompleta/${$this.id}`)
                    .then(res => {
                        $this.concluido = true;
                        if (res.data.success) {
                            $this.pergunta = res.data.data;

                            $this.pergunta.dtPerguntaFormat = moment($this.pergunta.dtPergunta).format('DD/MM/YYYY [às] HH:mm');
                            $this.pergunta.dtPrazoFormat = moment($this.pergunta.dtPrazo).format('DD/MM/YYYY [às] HH:mm');

                            if ($this.pergunta.perguntaMovimento != null) {
                                $this.pergunta.dtMovimento = moment($this.pergunta.perguntaMovimento.dtMovimento).format('DD/MM/YYYY [às] HH:mm');
                            } else {
                                $this.pergunta.dtMovimento = null;
                            }

                            $this.pergunta.tipoPergunta.icone = getIconeTipoPergunta($this.pergunta.tipoPergunta.nmTipoPergunta);

                        } else {
                            avisoErro("Não foi possível a orientação.");
                        }
                    })
                    .catch(res => {
                        $this.concluido = true;
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data.msg);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        //loading.hide();
                    });
            },

            formatData(data) {
                return moment(data).format('DD/MM/YYYY [às] HH:mm');
            },


            complementaInformacao(idMovimento) {
                let $this = this;
                axios.post(`${urlApi}/PerguntaMovimento/ComplementaInformacao`, { idMovimento: idMovimento, dsMovimento: this.complemento })
                    .then(res => {
                        //$this.$store.commit('hideLoading');
                        if (res.data.success) {
                            $this.load();
                        } else {
                            avisoErro("Não foi possível registrar seu complemento.");
                        }
                    })
                    .catch(function () {
                        //$this.$store.commit('hideLoading');
                        avisoErro("Não foi possível registrar seu complemento.");
                        //avisoErro(res.response.statusText);
                    })
            },

            mudarPrazo(idPerguntaDilatacaoPrazo, flAceite) {
                alert(idPerguntaDilatacaoPrazo);
                alert(flAceite);
            },

        },
        created() {
            this.load();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .box-borda-cinza {
        background: #FFFFFF;
        border: 2px solid #767676;
        box-sizing: border-box;
        border-radius: 10px;

        padding: 20px;
    }

    .box-borda-roxo {
        background: #FFFFFF;
        border: 2px solid #732A90;
        box-sizing: border-box;
        border-radius: 10px;

        padding: 20px;
    }

    .resposta {
        background: #F5F5F5;
        padding: 1.5em;
    }

    .resposta-rigth {
        display: flex;
        flex-direction: column;
        align-items: end;
    }

    .item-arquivo-audio {
        padding: 10px;
        border: 2px solid #732A90;
        border-radius: 5px;

        display: flex;
        
        justify-content: space-between;
        align-items: center;

    }
</style>

